// Required JS from local files
import { dfmAlert } from "./dfm5";
import { 
   dfm_generateQuestionContent, 
   showHTMLAnswer 
} from "./question-util";

// We look for a div, followed by any number of attributes then one called 'class', which can use either type of quotes
// and contains the distinct word "desmos" within its attribute value
const desmosDivRegex = /<div[^>]*\bclass=['"][^'"]*\bdesmos\b/;

function doesWorksheetContainDesmosImages(questions) {
   var containsDesmos = false;
   $.each(questions, function(k,q) {
      if(q.answer.type=="desmos" || q.answer.type=="desmos_line")containsDesmos = true;
      if(q.content.match(desmosDivRegex) || q.response.match(desmosDivRegex)) containsDesmos = true;
   });
   console.log("Contains Desmos: "+JSON.stringify(containsDesmos));
   return containsDesmos;
}

// This method, used by the worksheets interface when exporting to Word, generates all Desmos images needed for the Word output.

export function generateImagesForWorksheetNew(questions, callback) {
   dfmAlert("<h2>We're generating the images for this worksheet.</h2><p>Please wait... <span id='complete'>0</span>/<span id='outof'></span></p><div id='question-images' style='visibility:none;height:100px;overflow-y:hidden'></div>");
   if(doesWorksheetContainDesmosImages(questions))generateIndividualRequiredImagesNew(questions, callback);
   else callback();
   return false;
}

function generateIndividualRequiredImagesNew(questions, callback) {
   let imagesToProcess = 0;
   let outof = 0;
   for(var i=0; i<questions.length; i++) {

      $("#question-images").append("<h3>"+(i+1)+"</h3>");

      const idRegex = /id=['"](.*?)['"]/g;

      // Need to have new ids for any Desmos images.
      var desmosImageIds = [...questions[i].content.matchAll(idRegex)];
      if(desmosImageIds.length) {
         for(var k=0; k<desmosImageIds.length; k++) {
            questions[i].content = questions[i].content.replaceAll(desmosImageIds[k][1], desmosImageIds[k][1]+"-fresh");
         }
      }
      desmosImageIds = [...questions[i].response.matchAll(idRegex)];
      if(desmosImageIds.length) {
         for(var k=0; k<desmosImageIds.length; k++) {
            questions[i].response = questions[i].response.replaceAll(desmosImageIds[k][1], desmosImageIds[k][1]+"-fresh");
         }
      }

      if(questions[i].answer.type==="desmos" || questions[i].answer.type=="desmos_line") {
         // Answer input
         $("#question-images").append("Answer Input:<br><div id='question-area-"+i+"-ai' style='margin: 0px'></div>");
         $("#question-area-"+i+"-ai").data("repressInput", true);
         dfm_generateQuestionContent($("#question-area-"+i+"-ai"), questions[i], function(event) {
             return submitHandler();
         });
         $("#question-area-"+i+"-ai").find("input[type=submit]").remove();
         $("#question-area-"+i+"-ai").find(".question-content").remove();
         if(!questions[i].qid) {
            $("#question-area-"+i+"-ai").find('.desmos-calculator').data("ssid", questions[i].subskill.ssid);
            $("#question-area-"+i+"-ai").find('.desmos-calculator').data("params", questions[i].params);
         } else {
            $("#question-area-"+i+"-ai").find('.desmos-calculator').data("qid", questions[i].qid);
         }
         $("#question-area-"+i+"-ai").find('.desmos-calculator').data("type", "ai");

         // Answer
         var answerHTML = showHTMLAnswer(questions[i], questions[i].answer.correctAnswer);
         $("#question-images").append("Answer:<br><div id='question-area-"+i+"-a' style='margin: 0px'></div>");
         $("#question-area-"+i+"-a").html(answerHTML);
         $("#question-area-"+i+"-a").find('.desmos-calculator-solution').dfmDesmosLine({
            answerData: questions[i].answer.data,
            answer: questions[i].answer.correctAnswer
         });
         if(!questions[i].qid) {
            $("#question-area-"+i+"-a").find('.desmos-calculator-solution').data("ssid", questions[i].subskill.ssid);
            $("#question-area-"+i+"-a").find('.desmos-calculator-solution').data("params", questions[i].params);
         } else {
            $("#question-area-"+i+"-a").find('.desmos-calculator-solution').data("qid", questions[i].qid);
         }
         $("#question-area-"+i+"-a").find('.desmos-calculator-solution').data("type", "a");


      }
      if(questions[i].content && questions[i].content.match(desmosDivRegex)) {
         $("#question-images").append("Within question:<br><div id='question-area-"+i+"-q1' style='margin: 0px'></div>");
         dfm_generateQuestionContent($("#question-area-"+i+"-q1"), questions[i], function(event) {
             return submitHandler();
         });

         $("#question-area-"+i+"-q1").find(".question-content").children('p').remove();
         $("#question-area-"+i+"-q1").find(".answer-content").remove();
         $("#question-area-"+i+"-q1").find("input[type=submit]").remove();
         if(questions[i].subskill) {
            $("#question-area-"+i+"-q1").find('.desmos').data("ssid", questions[i].subskill.ssid);
            $("#question-area-"+i+"-q1").find('.desmos').data("params", questions[i].params);
         } else {
            $("#question-area-"+i+"-q1").find('.desmos').data("qid", questions[i].qid);
         }
         $("#question-area-"+i+"-q1").find('.desmos').each(function(i) {
            $(this).data("type", "q");
            $(this).data("num", i+1);
         });
      }
      if(questions[i].response && questions[i].response.match(desmosDivRegex)) {
         $("#question-images").append("Within response:<br><div id='question-area-"+i+"-r1' style='margin: 0px'></div>");
         $("#question-area-"+i+"-r1").html(questions[i].response);
         if(questions[i].subskill) {
            $("#question-area-"+i+"-r1").find('.desmos').data("ssid", questions[i].subskill.ssid);
            $("#question-area-"+i+"-r1").find('.desmos').data("params", questions[i].params);
         } else {
            $("#question-area-"+i+"-r1").find('.desmos').data("qid", questions[i].qid);
         }
         $("#question-area-"+i+"-r1").find('.desmos').each(function(i) {
            $(this).data("type", "r");
            $(this).data("num", i+1);
         });
      }
   }

   setTimeout(function(){
      if($("#question-images").find('.desmos, .desmos-calculator, .desmos-calculator-solution').length==0)callback(false);
      $("#question-images").find('.desmos, .desmos-calculator, .desmos-calculator-solution').each(function() {
         var desmosDiv = $(this);
         var calculator = $(this).data('calculator');
         var d = $(this);
        imagesToProcess++; 
        outof++;
         $("#outof").html(outof);
        if(!calculator) {
           dfmAlert("Something went wrong. Could not find Desmos area for question "+$(this).attr('id')+"<br><br>"+$(this).data('ssid'));
           return;
        }
         calculator.asyncScreenshot({showLabels: true, preserveAxisNumbers: true, mode: 'contain' }, function(img) {
            console.log("#### SSID = "+desmosDiv.data('ssid')+" NUM = "+desmosDiv.data('num')+" TYPE = "+desmosDiv.data('type'));
            var data = {}
            if(!desmosDiv.data('qid')) {
               data.ssid = desmosDiv.data('ssid');
               data.params = desmosDiv.data('params');
            } else {
               data.qid = desmosDiv.data('qid');
            }
            data.type = desmosDiv.data('type');
            if(desmosDiv.data('num'))data.num = desmosDiv.data('num');
            data.imageData = img;
            if(desmosDiv.data('ssid'))console.log("Making image generation request: ssid="+desmosDiv.data('ssid')+" params="+JSON.stringify(desmosDiv.data('params'))+" type="+desmosDiv.data('type'));
            else console.log("Making image generation request: qid="+desmosDiv.data('qid')+" type="+desmosDiv.data('type'));

            console.log("/api/worksheets/desmospic");
            $.ajax({
               url: "/api/worksheets/desmospic",
               type: "PUT",
               contentType:false,
               processData: false,
               cache: false,
               data: JSON.stringify(data),
               success: function(data){
                  console.log("Successfully saved image to "+data.url);
                  imagesToProcess--;
                  $("#complete").html(outof - imagesToProcess);
                  d.hide();
                  if(imagesToProcess==0)callback(true); // we're finished, so execute callback function
               },
               error: function(j, textStatus, errorThrown) {
                  dfmAlert("An error occurred: <strong>"+errorThrown+"</strong>");
               }
            }); 
         });
      });

   }, 1500);

}

